import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import FormHelperText from '@material-ui/core/FormHelperText';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { changeEmail } from '../Networking/APIClient';
import Typography from '@material-ui/core/Typography';

const progressStyle = {
    marginTop: 40,
    marginBottom: 31,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '85%',
};

const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20
}

const buttonStyle = {
    width: 100,
    marginLeft: 20,
};

const passwordStyle = {
    width: '100%',
    marginTop: 16,
    marginBottom: 8,
}

const editTextStyle = {
    width: '100%',
    marginTop: 8,
    marginBottom: 4,
}

const helperTextStyle = {
    marginTop: 5,
    color: '#f44336',
    padding: 0,
}

let self;
let t;
let error_message;
/**
 * Change of email is perfomed in 2 steps:
 * 1) ChangeEmail(old email,password,new email,null);
 *      A reset code is generated and emailed to the old email.
 *      If the credetials is not correct or either email 
 *      given is not parseable it will not generate the code,
 *      nor send the email.
 * 2) ChangeEmail(old email,new email,execute_id)
 *      The user enters the reset code (execute_id) received on email
 *      If the code is wrong, already used or created sometime ago 
 *      it will not change the email.
 */

class ChangeEmail extends Component {
    constructor(props) {
        super(props);

        self = this;
        t = props.t;

        this.state = {
            /**
             * Page states:
             * before (step1- type the inputs)
             * verify (step2 - type code)
             * after (fail or succeed page)
             */
            currentPageState: 'before',
            success: null,
            email: {
                value: props.credentials.email !== null && !props.usingValueCode ? props.credentials.email : '',
                error: false,
                helperText: '',
                showPassword: false
            },
            currentPassword: {
                value: props.credentials.password !== 'NotASecret' ? props.credentials.password : '',
                error: false,
                helperText: '',
                showPassword: false
            },  
            resetCodeTextField: {
                value: '',
                error: false,
                helperText: '',
            },
            newEmail: {
                value: '',
                error: false,
                helperText: '',
                showPassword: false
            },
            repeatNewEmail: {
                value: '',
                error: false,
                helperText: '',
                showPassword: false
            }
        }
    }

  
    // Ok button for step 1
    onSaveClicked = e => {
        e.preventDefault();

        const onOk = function onOk(is_execute_id_sent, is_email_changed) {
            if (is_execute_id_sent === true) {
                self.setState({
                    waitingForResponse: false,
                    currentPageState: 'verify',
                    success: true
                });
            } else {
                error_message = 'unknown_error';
                self.setState({
                    waitingForResponse: false,
                    currentPageState: 'after',
                    success: false,
                });
            }
        };

        const onError = function onError(error) {
            error_message = error;
            self.setState({
                waitingForResponse: false,
                currentPageState: 'after',
                success: false,
            });
        };

        let shouldChangeEmail = true;

        if (isEmpty(this.state.email.value)) {
            shouldChangeEmail = false;
            self.setState((prevState) => {
                return {
                    email: {
                        value: prevState.email.value,
                        error: true,
                        helperText: t('cannot_be_empty'),
                    }
                }
            });
        }

        if (isEmpty(this.state.currentPassword.value)) {
            shouldChangeEmail = false;
            self.setState((prevState) => {
                return {
                    currentPassword: {
                        value: prevState.currentPassword.value,
                        error: true,
                        helperText: t('cannot_be_empty'),
                    }
                }
            });
        }

        if (isEmpty(this.state.newEmail.value)) {
            shouldChangeEmail = false;
            self.setState((prevState) => {
                return {
                    newEmail: {
                        value: prevState.newEmail.value,
                        error: true,
                        helperText: t('cannot_be_empty'),
                    }
                }
            });
        }
        if (!this.state.newEmail.value.includes('@')) {
            shouldChangeEmail = false;
            self.setState((prevState) => {
                return {
                    newEmail: {
                        value: prevState.newEmail.value,
                        error: true,
                        helperText: t('must_be_valid'),
                    }
                }
            });
        }

        if (this.state.newEmail.value !== this.state.repeatNewEmail.value) {
            shouldChangeEmail = false;
            self.setState((prevState) => {
                return {
                    newEmail: {
                        value: prevState.newEmail.value,
                        error: true,
                        helperText: t('email_must_match'),
                        showPassword: prevState.newEmail
                    },
                    repeatNewEmail: {
                        value: prevState.repeatNewEmail.value,
                        error: true,
                        helperText: t('email_must_match'),
                        showPassword: prevState.repeatNewEmail.showPassword
                    }
                }
            });
        }

        if (shouldChangeEmail) {
            changeEmail(this.state.email.value, this.state.currentPassword.value, this.state.newEmail.value, '', onOk, onError);
            self.setState({
                waitingForResponse: true
            });
        }
    }

    onCancelClicked = e => {
        e.preventDefault();

        self.setState({
            currentPageState: 'before',
            email: {
                value: self.props.credentials.email !== null && !self.props.usingValueCode ? self.props.credentials.email : '',
                error: false,
                helperText: '',
                showPassword: false
            },
            currentPassword: {
                value: self.props.credentials.password !== 'NotASecret' ? self.props.credentials.password : '',
                error: false,
                helperText: '',
                showPassword: false
            },
            newEmail: {
                value: '',
                error: false,
                helperText: '',
                showPassword: false
            },
            repeatNewEmail: {
                value: '',
                error: false,
                helperText: '',
                showPassword: false
            }
        });
    }

    // Ok button for the verification step
    onVerifyClicked = e => {
        e.preventDefault();
        const onOk = function onOk(is_execute_id__sent, is_email_changed) {
            if (is_email_changed === true) {
                self.setState({
                    waitingForResponse: false,
                    currentPageState: 'after',
                    success: true
                });
                // Update credentials in main.
                self.props.setCredentials({
                    email: self.state.newEmail.value,
                    password: self.state.currentPassword.value
                });

                // At this point we are no longer using value code as credentials.
                // This must be updated.
                self.props.setUsingValueCode(false);
                self.props.updateAppData();
            } else {
                self.setState({
                    waitingForResponse: false,
                    resetCodeTextField: {
                        value: '',
                        error: true,
                        helperText: t('unknown_error')
                    }
                });
            }
        };
       

        const onError = function onError(error) {
                let feedbackText = t(error);
                self.setState({
                    waitingForResponse: false,
                    resetCodeTextField: {
                        value: '',
                        error: true,
                        helperText: feedbackText
                    }
                });
        };

        // Verify reset code
        if (!isEmpty(this.state.resetCodeTextField.value)) {
            self.setState({
                waitingForResponse: true
            });
            changeEmail(this.state.email.value, this.state.currentPassword.value, this.state.newEmail.value,this.state.resetCodeTextField.value, onOk, onError);
        }
    }
    
    onFinishClicked = e => {
        e.preventDefault();
        self.props.updatePage('account_overview');
    }

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    handleClickShowCurrentPassword = () => {
        this.setState((prevState) => {
            return {
                currentPassword: {
                    value: prevState.currentPassword.value,
                    error: prevState.currentPassword.error,
                    helperText: prevState.currentPassword.helperText,
                    showPassword: !prevState.currentPassword.showPassword
                }
            }
        });
    };

    handleClickShowNewEmail = () => {
        this.setState((prevState) => {
            return {
                newEmail: {
                    value: prevState.newEmail.value,
                    error: prevState.newEmail.error,
                    helperText: prevState.newEmail.helperText,
                    showPassword: !prevState.newEmail.showPassword
                }
            }
        });
    };

    handleClickShowRepeatNewEmail = () => {
        this.setState((prevState) => {
            return {
                repeatNewEmail: {
                    value: prevState.repeatNewEmail.value,
                    error: prevState.repeatNewEmail.error,
                    helperText: prevState.repeatNewEmail.helperText,
                    showPassword: !prevState.repeatNewEmail.showPassword
                }
            }
        });
    };

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: {
                ...this.state[name],
                value: event.target.value
            }
        });
    };

    // This method is needed so that the soft keyboard of phones closes
    // when the "submit" button of the soft keyboard is clicked
    // on the last text field
    onKeyPressed = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            document.activeElement.blur();
        }
    }

    render() {
        let content;
        switch (this.state.currentPageState) {
            case 'before':
                content =
                    <div className="content-container">
                        <div className="typography-title-container">
                            <Typography variant="title">
                                {t('change_email')}
                            </Typography>
                        </div>
                        <div className="typography-title-container">
                            <Typography variant="subheading">
                                {t('change_email_information')}
                            </Typography>
                        </div>
                        <form>
                            <TextField style={editTextStyle}
                                error={this.state.email.error}
                                id="email"
                                value={this.state.email.value}
                                label={t('email')}
                                onChange={this.handleChange('email')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                margin="normal" />
                            <FormControl style={passwordStyle}>
                                <InputLabel htmlFor="currentPassword">{t('current_password')}</InputLabel>
                                <Input
                                    id="currentPassword"
                                    type={this.state.currentPassword.showPassword ? 'text' : 'password'}
                                    value={this.state.currentPassword.value}
                                    error={this.state.currentPassword.error}
                                    onChange={this.handleChange('currentPassword')}
                                    onKeyPress={e => this.onKeyPressed(e)}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="Toggle password visibility"
                                                onClick={this.handleClickShowCurrentPassword}
                                                onMouseDown={this.handleMouseDownPassword}>
                                                {this.state.currentPassword.showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            <FormHelperText style={helperTextStyle} id="weight-helper-text">{this.state.currentPassword.helperText}</FormHelperText>
                            </FormControl>
                            <FormControl style={editTextStyle}>
                                <InputLabel htmlFor="newEmail">{t('new_email')}</InputLabel>
                                <Input
                                    id="newEmail"
                                    value={this.state.newEmail.value}
                                    error={this.state.newEmail.error}
                                    onChange={this.handleChange('newEmail')}
                                    onKeyPress={e => this.onKeyPressed(e)}
                                />
                            <FormHelperText style={helperTextStyle} id="weight-helper-text">{this.state.newEmail.helperText}</FormHelperText>
                            </FormControl>
                            <FormControl style={editTextStyle}>
                                <InputLabel htmlFor="repeatNewEmail">{t('repeat_new_email')}</InputLabel>
                                <Input
                                    id="repeatNewEmail"                                
                                    value={this.state.repeatNewEmail.value}
                                    error={this.state.repeatNewEmail.error}
                                    onChange={this.handleChange('repeatNewEmail')}
                                    onKeyPress={e => this.onKeyPressed(e)}                                    
                                />
                               <FormHelperText style={helperTextStyle} id="weight-helper-text">{this.state.repeatNewEmail.helperText}</FormHelperText>
                               </FormControl>
                        </form>
                        <div style={buttonContainerStyle}>
                            <Button
                                style={buttonStyle}
                                variant="contained"
                                color="primary"
                                onClick={e => this.onSaveClicked(e)}>
                                {t('save')}
                            </Button >
                        </div>
                    </div>
                break;
            case 'verify':
                content =
                    <div className="content-container">
                        <div className="typography-title-container">
                            <Typography variant="title">
                                {t('enter_code')}
                            </Typography>
                        </div>
                        <div>
                            <Typography variant="subheading">
                                {t('check_the_inbox_of')} {this.state.email.value}, {t('and_enter_the_6_digit_code_below')}
                            </Typography>
                        </div>
                        <div>
                            <TextField
                                value={this.state.resetCodeTextField.value}
                                error={this.state.resetCodeTextField.error}
                                type='number'
                                id="resetCodeTextField"
                                label={t('code')}
                                onChange={this.handleChange('resetCodeTextField')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                style={editTextStyle}
                                margin="normal" />
                            <FormHelperText style={helperTextStyle} id="weight-helper-text">{this.state.resetCodeTextField.helperText}</FormHelperText>
                        </div>
                        {this.state.waitingForResponse ?
                            <LinearProgress style={progressStyle} color="primary" variant="query" />
                            :
                            <div style={buttonContainerStyle}>
                                <Button
                                    style={buttonStyle}
                                    variant="text"
                                    color="default"
                                    onClick={e => this.onCancelClicked(e)}>
                                    {t('cancel')}
                                </Button >
                                <Button
                                    style={buttonStyle}
                                    variant="contained"
                                    color="primary"
                                    onClick={e => this.onVerifyClicked(e)}>
                                    {t('verify')}
                                </Button >
                            </div>
                        }
                    </div>
            break;
            case 'after':
                content =
                    <div className="content-container">
                        <div>
                            <div className="typography-title-container">
                                <Typography variant="title" color={this.state.success ? "default" : "error"}>
                                    {this.state.success ? t('email_changed_title') : t('email_change_failed_title')}
                                </Typography>
                            </div>
                            <div>
                                <Typography variant="subheading">
                                    {this.state.success ? t('email_changed_message') : t(error_message)}
                                </Typography>
                            </div>
                            <div style={buttonContainerStyle}>
                                <Button
                                    style={buttonStyle}
                                    variant="contained"
                                    color="primary"
                                    onClick={e => this.state.success ? this.onFinishClicked(e) : this.onCancelClicked(e)}>
                                    {t('finished')}
                                </Button >
                            </div>
                        </div>
                    </div>;
                break;
            default:
                break;
        }

        return (
            <div className="content-frame">
                <Paper className="content">
                    {content}
                </Paper>
            </div>);
    }
}

function isEmpty(value) {
    return value === '';
}

export default ChangeEmail;









// WEBPACK FOOTER //
// ./src/Pages/ChangeEmail.js